import React from 'react';
import { TextItem, HeaderActions } from '../components';
import { OutputColumn } from '../columns';
import { IHeaderAction } from 'domains/designers/TruthTable/components/HeaderActions';
import { Cell } from '../cells';

export interface IHeaderOutputProps extends Omit<React.HTMLProps<HTMLTableCellElement>, 'children'> {
  name: string;
  canRemove?: boolean;
  canEdit?: boolean;
  onDeleteClick?: () => void;
  onEditClick?: () => void;
}

/**
 *
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function HeaderOutput({
  name,
  canRemove,
  canEdit,
  className,
  onDeleteClick,
  onEditClick,
  ...otherProps
}: IHeaderOutputProps) {
  const actions: IHeaderAction[] = [];

  if (canRemove) {
    actions.push({
      /*TODO alex: Rename method to "onRemoveClick" or css className to "tt-result-delete" to be consistent */
      iconClassName: 'tt-result-remove',
      title: 'Remove output',
      action: () => onDeleteClick?.(),
    });
  }

  if (canEdit) {
    actions.push({
      iconClassName: 'tt-result-edit',
      title: 'Edit output',
      action: () => onEditClick?.(),
    });
  }

  return (
    <OutputColumn className={className} {...otherProps} isHeader data-column-name={name}>
      <Cell className="tt-header-result flex-centering">
        <TextItem>{name}</TextItem>
        <HeaderActions actions={actions} />
      </Cell>
    </OutputColumn>
  );
}
